/*
 * File: with-muted-prop-warn.ts
 * Created: 2026-01-16 08:23:34
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2026-01-16 08:23:54
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import Vue from "vue";

export function withMutedPropWarn(fn: () => void) {
    const prev = Vue.config.warnHandler;

    Vue.config.warnHandler = (msg, vm, trace) => {
        const isTarget =
            typeof msg === "string" &&
            msg.includes("Avoid mutating a prop directly") &&
            msg.includes("Prop being mutated");

        if (isTarget) return; // ✅ 只關掉這一條

        if (prev) return prev(msg, vm, trace);
        // fallback：如果原本沒 warnHandler，交給 console
        // eslint-disable-next-line no-console
        console.warn(`[Vue warn]: ${msg}${trace || ""}`);
    };

    try {
        fn();
    } finally {
        Vue.config.warnHandler = prev;
    }
}
